import React, { useState, useMemo, useCallback, useEffect } from 'react';
import useEmblaCarousel from 'embla-carousel-react';
import Fade from 'embla-carousel-fade';
import Autoplay from 'embla-carousel-autoplay';
import { WheelGesturesPlugin } from 'embla-carousel-wheel-gestures';
import cx from 'classnames';
import { useWindowSize } from '../../../../utils/hooks/useWindowSize.js';
import '../../buttons/BabyButton/Base.js';
import '../../buttons/BabyButton/variants/Chat/index.js';
import '../../buttons/BabyButton/variants/Menu/index.js';
import '../../buttons/BabyButton/variants/User/index.js';
import '../../buttons/BabyButton/variants/Vip/index.js';
import '../../buttons/BabyButton/variants/Wallet/index.js';
import '../../buttons/Button/index.js';
import '../../buttons/CloseButton/index.js';
import { DirectionButton } from '../../buttons/DirectionButton/index.js';
import '../../buttons/GradientButton/index.js';
import '../../buttons/GradientButtonV2/index.js';
import '../../buttons/TabButton/index.js';
import '../../buttons/TabButtonV2/index.js';
import '../../buttons/TimerButton/index.js';
import '../../buttons/TimerButtonV2/index.js';
import '../../buttons/TimerButtonV3/index.js';
import '../../../feature/affilates/AffilatePanel/index.js';
import '../../../feature/affilates/AffilateProgram/index.js';
import '../../../feature/affilates/AffilatesTabs/index.js';
import '../../../feature/affilates/AffilatesNavBanner/index.js';
import '../../../icons/ActivityIcon.js';
import '../../../icons/AgeIcon.js';
import '../../../icons/ArrowDownV2.js';
import '../../../icons/ArrowDownV3.js';
import '../../../icons/ArrowDown.js';
import '../../../icons/ArrowLeftBig.js';
import '../../../icons/ArrowLeft.js';
import '../../../icons/ArrowLeft2.js';
import '../../../icons/ArrowsDown.js';
import '../../../icons/ArrowsUp.js';
import '../../../icons/ArrowUpRightIcon.js';
import '../../../icons/Baccarat.js';
import '../../../icons/BlackJack.js';
import '../../../icons/BookIcon.js';
import '../../../icons/Calendar.js';
import '../../../icons/Carts.js';
import '../../../icons/ChartIcon.js';
import '../../../icons/ChainIcon.js';
import '../../../icons/CheckIcon2.js';
import '../../../icons/CheckIcon.js';
import '../../../icons/Checks.js';
import '../../../icons/ChevronDown.js';
import '../../../icons/Clock.js';
import '../../../icons/Close.js';
import '../../../icons/CoinsIcon.js';
import '../../../icons/Coins.js';
import '../../../icons/CopyIconDouble.js';
import '../../../icons/CopyIconFill.js';
import '../../../icons/Crown.js';
import '../../../icons/CryptoCurrency.js';
import '../../../icons/DiscordIcon.js';
import '../../../icons/DiscordIconV2.js';
import '../../../icons/Dota2.js';
import '../../../icons/Edit.js';
import '../../../icons/ExtendIcon.js';
import '../../../icons/EyeOff.js';
import '../../../icons/Eye.js';
import '../../../icons/FacebookIconV2.js';
import '../../../icons/FacebookIcon.js';
import '../../../icons/FiatCurrency.js';
import '../../../icons/FilterIcon.js';
import '../../../icons/GameIcon.js';
import '../../../icons/GameShows.js';
import '../../../icons/Game.js';
import '../../../icons/HeadPhones.js';
import '../../../icons/HomeIcon.js';
import '../../../icons/Horse.js';
import '../../../icons/InfoFill.js';
import '../../../icons/InfoIcon2.js';
import '../../../icons/InfoIcon.js';
import '../../../icons/InfoOutline.js';
import '../../../icons/LevelUp.js';
import '../../../icons/LinkIcon.js';
import '../../../icons/Link.js';
import '../../../icons/LiveCasino.js';
import '../../../icons/LiveIcons2.js';
import '../../../icons/LobbyIconV2.js';
import '../../../icons/LobbyIcon.js';
import '../../../icons/LogoSmallIcon.js';
import '../../../icons/Lock.js';
import '../../../icons/LOL.js';
import '../../../icons/MaxIcon.js';
import '../../../icons/MedalIcon.js';
import '../../../icons/MedalStarIcon.js';
import '../../../icons/MoneyBagIcon.js';
import '../../../icons/MoneyIcon.js';
import '../../../icons/MoneyRecive.js';
import '../../../icons/NewTwitterIcon.js';
import '../../../icons/OriginalsIcon.js';
import '../../../icons/Original.js';
import '../../../icons/PersonIcon.js';
import '../../../icons/PhoneChatIcon.js';
import '../../../icons/PhotoUp.js';
import '../../../icons/PlayIcon.js';
import '../../../icons/PlusIcon.js';
import '../../../icons/RainIcon.js';
import '../../../icons/RankIcon.js';
import '../../../icons/RankinIcon.js';
import '../../../icons/ReferalIcon.js';
import '../../../icons/RefreshIcon.js';
import '../../../icons/Reload.js';
import '../../../icons/Roulette.js';
import '../../../icons/Search2Icon.js';
import '../../../icons/Search.js';
import '../../../icons/SendIcon.js';
import '../../../icons/Settings2.js';
import '../../../icons/SettingsV3.js';
import '../../../icons/Settings.js';
import '../../../icons/SlotsIcon2.js';
import '../../../icons/SlotsIcon.js';
import '../../../icons/SmileIcon.js';
import '../../../icons/SocialsIcon.js';
import '../../../icons/SortIcon.js';
import '../../../icons/SponsorshipIcon.js';
import '../../../icons/StarFill.js';
import '../../../icons/StarCraft.js';
import '../../../icons/StopIcon.js';
import '../../../icons/TableGamesIcon.js';
import '../../../icons/TelegramIcon.js';
import '../../../icons/TelegramIconV2.js';
import '../../../icons/TopPicksIcon.js';
import '../../../icons/Upload.js';
import '../../../icons/UserMoney.js';
import '../../../icons/UsersIconV2.js';
import '../../../icons/UsersIcon.js';
import '../../../icons/VerifiedIcon.js';
import '../../../icons/WalletAddIcon.js';
import '../../../icons/Wallet.js';
import '../../../icons/WarningIcon.js';
import '../../../icons/DeviceDesktop.js';
import '../../../icons/DeviceTablet.js';
import '../../../icons/DevicePhone.js';
import '../../../icons/ClockOrange.js';
import '../../../icons/CalendarOrange.js';
import '../../../icons/OpenLinkIcon.js';
import '../../../icons/FavoriteFill.js';
import '../../../icons/EditorChoiceV2.js';
import '../../../icons/ListBullet.js';
import '../../../icons/BankIcon.js';
import '../../../icons/ClockOrangeV2.js';
import '../../../icons/CalendarOrangeV2.js';
import '../../../icons/ReferralIconV2.js';
import '../../../icons/MoneyIconV2.js';
import '../../../icons/UsersIconV3.js';
import '../../../icons/InfoFillV2.js';
import '../../../icons/LockOrange.js';
import '../../../icons/LockV2.js';
import '../../../icons/AlertOrange.js';
import '../../../icons/LiveSupportV2.js';
import '../../../icons/Chat.js';
import '../../../icons/CrossCircle.js';
import '../../../icons/LockV3.js';
import '../../../icons/CoinCrypto.js';
import '../../accordions/Accordion/index.js';
import '../../accordions/AccordionSelect/index.js';
import '../../badges/Badge/index.js';
import '../../badges/BadgeIcon/index.js';
import '../../badges/Checked/index.js';
import '../../badges/Panel/index.js';
import '../../badges/Status/index.js';
import '../../badges/Tag/index.js';
import '../../loaders/Loader/index.js';
import '../../loaders/ScreenLoader/index.js';
import '../../modals/Modal/MobileWrapperV2/index.js';
import '../../modals/Modal/Modal.js';
import '../../modals/Modal/ModalContentWrapper/index.js';
import '../../popups/Popper/index.js';
import '../../popups/Popup/BasePopup/index.js';
import '../../popups/Popup/Thumb/index.js';
import '../../popups/Popup/ThumbV2/index.js';
import '../../popups/Popup/InfoTooltip/index.js';
import '../../tables/Table/index.js';
import '../../tables/Table/TableTd/index.js';
import '../../tabs/Tabs/index.js';
import '../../tabs/TabsV2/index.js';
import '../../texts/CryptoValue/index.js';
import '../../texts/AmountValue/index.js';
import '../../texts/TitleWithCurrency/index.js';
import '../../texts/Text/index.js';
import '../../texts/TextNavigation/index.js';
import '../../texts/MinValue/index.js';
import '../../socials/SocialsList/index.js';
import '../../../feature/transactions/TransactionID/index.js';
import '../../../feature/transactions/TransactionLayout/index.js';
import '../../../feature/transactions/TransactionPanel/index.js';
import '../../../feature/transactions/TransactionTabs/index.js';
import '../../../feature/transactions/TransactionToolbar/index.js';
import '../../../feature/affilates/Panels/DashboardPanel/index.js';
import '../../../feature/affilates/Panels/EarningsPanel/index.js';
import '../../../feature/affilates/ProgramDescription/index.js';
import '../../../feature/auth/common/Steps/index.js';
import '../../../feature/auth/common/StepsWrapper/index.js';
import '../../../feature/auth/common/Wrapper/index.js';
import '../../../feature/auth/Form/AddReferral/index.js';
import '../../../feature/auth/Form/Button/index.js';
import '../../../feature/auth/Form/Divider/index.js';
import '../../../feature/auth/Form/ForgotPassword/index.js';
import '../../../feature/auth/Form/FormGroup/index.js';
import '../../../feature/auth/Form/FormTitle/index.js';
import '../../../feature/auth/Form/NavLink/index.js';
import '../../../feature/auth/Form/Row/index.js';
import '../../../feature/auth/Form/Wrapper/index.js';
import '../../../feature/auth/Form/FormSubTitle/index.js';
import '../../../feature/auth/Form/AnimationWrapper/index.js';
import '../../../feature/auth/Form/ForgotPasswordWrapper/index.js';
import '../../../feature/auth/Verification/index.js';
import '../../../feature/banners/TimerBanner/index.js';
import '../../../feature/banners/RaceToMars/index.js';
import '../../../feature/banners/BannerGrid/index.js';
import '../../../feature/banners/BannerGridV2/index.js';
import '../../../feature/banners/BannerGridV3/index.js';
import '../../../feature/charts/LiveStatsChart/index.js';
import '../../../feature/copy/CopyInput/index.js';
import '../../../feature/copy/CopyValue/index.js';
import '../../../feature/crypto/CryptoStatistic/index.js';
import '../../../feature/crypto/CryptoStatisticList/index.js';
import '../../../feature/footer/Footer/index.js';
import '../../../feature/footer/FooterContacts/index.js';
import '../../../feature/footer/FooterList/index.js';
import '../../../feature/forms/2FA/Button/index.js';
import '../../../feature/forms/2FA/LostPin/index.js';
import '../../../feature/forms/2FA/Row/index.js';
import '../../../feature/forms/2FA/Text/index.js';
import '../../../feature/forms/2FA/Wrapper/index.js';
import '../../../feature/forms/2FA/EmailHint/index.js';
import '../../../feature/forms/PinForm/ErrorMessage/index.js';
import '../../../feature/forms/PinForm/Row/index.js';
import '../../../feature/forms/PinForm/Wrapper/index.js';
import '../../../feature/forms/PinForm/Title/index.js';
import '../../../feature/forms/PinForm/Form/index.js';
import '../../../feature/forms/AdvVerify/Form/index.js';
import '../../../feature/forms/AdvVerify/Group/index.js';
import '../../../feature/forms/AdvVerify/Info/index.js';
import '../../../feature/forms/AdvVerify/Row/index.js';
import '../../../feature/forms/AdvVerify/Step/index.js';
import '../../../feature/forms/AdvVerify/Wrapper/index.js';
import '../../../feature/forms/BasicVerify/Form/index.js';
import '../../../feature/forms/BasicVerify/Row/index.js';
import '../../../feature/forms/BasicVerify/Wrapper/index.js';
import '../../../feature/forms/ChangePass/Form/index.js';
import '../../../feature/forms/ChangePass/Row/index.js';
import '../../../feature/forms/ChangePass/Wrapper/index.js';
import '../../../feature/forms/ContactVerify/Form/index.js';
import '../../../feature/forms/ContactVerify/Row/index.js';
import '../../../feature/forms/ContactVerify/Wrapper/index.js';
import '../../../feature/forms/TwoFactorAuth/Form/index.js';
import '../../../feature/forms/TwoFactorAuth/Row/index.js';
import '../../../feature/forms/TwoFactorAuth/Wrapper/index.js';
import '../../../feature/forms/TwoFactorAuth/WideButton/index.js';
import '../../../feature/forms/SecurityVerify/Content/index.js';
import '../../../feature/forms/SecurityVerify/Form/index.js';
import '../../../feature/forms/SecurityVerify/RequestCode/index.js';
import '../../../feature/forms/SecurityVerify/Title/index.js';
import '../../../feature/forms/SecurityVerify/Row/index.js';
import '../../../feature/forms/SecurityVerify/Value/index.js';
import '../../../feature/forms/SecurityVerify/Wrapper/index.js';
import '../../../feature/forms/SecurityVerify/EditValue/index.js';
import '../../../feature/forms/SelfExclusion/Form/index.js';
import '../../../feature/forms/SelfExclusion/Group/index.js';
import '../../../feature/forms/SelfExclusion/Row/index.js';
import '../../../feature/forms/SelfExclusion/Wrapper/index.js';
import '../../../feature/forms/Wallet/WalletForm/index.js';
import '../../../feature/forms/Wallet/Warning/index.js';
import '../../../feature/forms/VerifyForm/Form/index.js';
import '../../../feature/forms/VerifyForm/Row/index.js';
import '../../../feature/forms/VerifyForm/Wrapper/index.js';
import '../../../feature/forms/UserInfoEditForm/Row/index.js';
import '../../../feature/forms/UserInfoEditForm/Wrapper/index.js';
import '../../../feature/forms/UserInfoEditForm/Form/index.js';
import '../../../feature/forms/UserInfoEditForm/AvatarBlock/index.js';
import '../../../feature/forms/UserInfoEditForm/Title/index.js';
import '../../../feature/forms/UserInfoEditForm/Text/index.js';
import '../../../feature/forms/UserInfoEditForm/WrapperButtons/index.js';
import '../../../feature/forms/UserInfoEditForm/WarningIcon/index.js';
import '../../../feature/forms/LogoutForm/Row/index.js';
import '../../../feature/forms/LogoutForm/Wrapper/index.js';
import '../../../feature/forms/LogoutForm/WrapperButtons/index.js';
import '../../../feature/forms/LogoutForm/Title/index.js';
import '../../../feature/forms/LogoutForm/WrapperImage/index.js';
import '../../../feature/forms/LogoutForm/Image/index.js';
import '../../../feature/game/GameAccordion/index.js';
import '../../../feature/game/GameBanner/index.js';
import '../../../common/DateFormat/index.js';
import '@anton.bobrov/react-hooks';
import '@anton.bobrov/react-components';
import '../../../common/GradientWrapper/index.js';
import '../../../common/Icon/index.js';
import '../../../common/LazyImage/index.js';
import '../../../common/NumberFormat/index.js';
import '../../../common/WithCustomScrollbar/index.js';
import '../../../feature/game/GameStat/index.js';
import '../../../feature/game/GameStatTitle/index.js';
import '../../../feature/lists/GameList/GameListHeader/index.js';
import '../../../feature/lists/GameList/index.js';
import '../../../feature/lists/GamesListTopBar/index.js';
import '../../../feature/lists/LiveLoad/index.js';
import '../../../feature/lists/LiveWins/index.js';
import '../../../feature/lists/NavigationBar/index.js';
import '../../../feature/lists/PageNavigationBar/index.js';
import '../../../feature/lists/NavigationBarV2/index.js';
import '../../../feature/lists/PageNavigationBarV2/index.js';
import '../../../feature/lists/Pagination/index.js';
import '../../../feature/lists/PaginationLocal/index.js';
import '../../../feature/lists/ProvidersList/ProvidersListHeader/index.js';
import '../../../feature/lists/ProvidersList/index.js';
import '../../../feature/lists/SocialLinks/index.js';
import '../../../feature/modals/AccessModal/index.js';
import '../../../feature/modals/AuthModal/index.js';
import '../../../feature/modals/DefaultModal/index.js';
import '../../../feature/modals/FilterModal/index.js';
import '../../../feature/modals/LiveStats/Modal/index.js';
import '../../../feature/modals/LiveStats/Row/index.js';
import '../../../feature/modals/PlayModal/index.js';
import '../../../feature/modals/ProfileModal/index.js';
import '../../../feature/modals/RedeemCodeModal/index.js';
import '../../../feature/modals/UserInfoModal/UserInfoGameList/index.js';
import '../../../feature/modals/UserInfoModal/UserInfoRewardsList/index.js';
import '../../../feature/modals/UserInfoModal/Modal/index.js';
import '../../../feature/modals/UserInfoModal/Row/index.js';
import '../../../feature/modals/UserInfoModal/RowItem/index.js';
import '../../../feature/modals/UserInfoModal/UserInfoUser/index.js';
import '../../../feature/modals/UserInfoModal/Panel/index.js';
import 'react-router-dom';
import '../../../form/CheckBox/index.js';
import '../../../form/CodeInput/index.js';
import '../../../form/CryptoSelect/index.js';
import '../../../form/FileUploader/index.js';
import '../../../form/FormInput/index.js';
import '../../../form/FormSelect/index.js';
import '../../../form/PhoneInput/index.js';
import '../../../form/RadioButton/index.js';
import '../../../form/Select/index.js';
import '../../../form/SelectV2/index.js';
import '../../../form/SelectV3/index.js';
import '../../../form/SelectV4/index.js';
import '../../../form/Search/Input/index.js';
import '../../../form/Search/NoResults/index.js';
import '../../../form/Switch/index.js';
import '../../../form/DatePickerInput/index.js';
import '../../../cards/AuthPromo/index.js';
import '../../../cards/Card/index.js';
import '../../../cards/CategoryCard/index.js';
import '../../../cards/CryptoFeature/index.js';
import '../../../cards/GamePreview/index.js';
import '../../../cards/Promo/PromoCardSimple/index.js';
import '../../../cards/Promo/PromotionCard/index.js';
import '../../../cards/Provider/index.js';
import '../../../cards/SportsBook/index.js';
import '../../../cards/SecurityCard/index.js';
import '../../../cards/WinCard/index.js';
import '../../../feature/modals/AdvancedVerificationModal/index.js';
import '../../../feature/modals/BasicVerificationModal/index.js';
import '../../../feature/modals/ChangePasswordModal/index.js';
import '../../../feature/modals/ContactVerificationModal/index.js';
import '../../../feature/modals/TwoFactorAuthModal/index.js';
import '../../../feature/modals/VerificationPinModal/index.js';
import '../../../feature/modals/SelfExclusionModal/index.js';
import '../../../feature/modals/WalletModal/index.js';
import '../../../feature/modals/RewardsClaimModal/index.js';
import '../../../feature/modals/RewardsSliderInfoModal/index.js';
import '../../../feature/modals/VipRewardsModal/index.js';
import '../../../feature/modals/VerificationModal/index.js';
import '../../../feature/modals/ConfirmChangeSliderModal/index.js';
import '../../../feature/modals/ReconectSocketModal/index.js';
import '../../../feature/modals/LogoutModal/index.js';
import '../../../feature/modals/UnavailableModal/index.js';
import '../../../feature/modals/FA2Modal/index.js';
import '../../../feature/news/ArticleMetadata/index.js';
import '../../../feature/news/Article/index.js';
import '../../../feature/notifications/MarkAsReadButton/index.js';
import '../../../feature/notifications/Notification/index.js';
import '../../../feature/notifications/NotificationsList/index.js';
import '../../../feature/notifications/NotificationsModal/index.js';
import '../../../feature/notifications/NotificationsTabs/index.js';
import '../../../feature/notifications/NotificationsPopup/index.js';
import '../../../feature/qrcodes/QrCode/index.js';
import '../../../feature/rewards/Progress/index.js';
import '../../../feature/rewards/RewardIcon/index.js';
import '../../../feature/rewards/RewardIconWrapper/index.js';
import '../../../feature/rewards/RewardsProgressBar/index.js';
import '../../../feature/rewards/RewardStatus/index.js';
import '../../../feature/rewards/VipIcon/index.js';
import '../../../feature/rewards/InstantRakeback/index.js';
import '../../../feature/rewards/Range/index.js';
import '../../../feature/rewards/VipReload/index.js';
import '../../../feature/rewards/RewardWallet/index.js';
import '../../../feature/rewards/RewardHorizontal/index.js';
import '../../../feature/rewards/RewardHorizontalV2/index.js';
import '../../../feature/rewards/Reward/index.js';
import '../../../feature/rewards/AvailableProgress/index.js';
import '../../../feature/rewards/Benefits/index.js';
import '../../../feature/rewards/CountDownBanner/index.js';
import '../../../feature/rewards/ProgressWidget/index.js';
import '../../../feature/rewards/RewardsSliderPreview/index.js';
import '../../../feature/rewards/RewardsSlider/index.js';
import '../../../feature/rewards/VipLevelLine/index.js';
import '../../../feature/rewards/VipLevelAccordion/index.js';
import '../../../feature/rewards/VipProgress/index.js';
import '../../../feature/rewards/VipRewards/index.js';
import '../../../feature/rewards/RewardsList/index.js';
import '../../../feature/rewards/RewardTypeIcon/index.js';
import '../../../feature/rewards/RewardsDropdown/RDContent/index.js';
import '../../../feature/rewards/RewardsDropdown/RDFooter/index.js';
import '../../../feature/rewards/RewardsDropdown/RDHeader/index.js';
import '../../../feature/rewards/RewardsDropdown/RDList/index.js';
import '../../../feature/rewards/RewardsDropdown/RDRow/index.js';
import '../../../feature/rewards/RewardsDropdown/RDStatistic/index.js';
import '../../../feature/rewards/RewardsDropdown/RDWrapper/index.js';
import '../../../feature/sections/CategoryTitle/index.js';
import '../../../feature/sections/FadeUpWrapper/index.js';
import '../../../feature/sections/LoggedWelcomeText/index.js';
import '../../../feature/sections/PromoSection/index.js';
import { SectionTitle } from '../../../feature/sections/SectionTitle/index.js';
import '../../../feature/sections/SectionTitleV2/index.js';
import '../../../feature/sections/SignInText/index.js';
import '../../../feature/sections/TextNavigationWrapper/index.js';
import '../../../feature/sections/UnavailableSection/index.js';
import '../../../feature/sections/OtherServicesAuth/OtherServicesAuthModalText/index.js';
import '../../../feature/sections/OtherServicesAuth/OtherServicesAuthModalWrapper/index.js';
import '../../../feature/settings/SettingsTabs/index.js';
import '../../../feature/settings/Profile/EmailVerification/index.js';
import '../../../feature/settings/Profile/User/index.js';
import '../../../feature/settings/Security/LinkedAccounts/AccountItem/index.js';
import '../../../feature/settings/Security/LinkedAccounts/index.js';
import '../../../feature/settings/Security/Sessions/index.js';
import '../../../feature/settings/Panels/SecurityPanel/index.js';
import '../../../feature/settings/Panels/ProfilePanel/index.js';
import '../../../feature/settings/Panels/PreferencesPanel/index.js';
import '../../../feature/settings/Panels/GamingPanel/index.js';
import '../../../feature/settings/Panels/IgnoredUsersPanel/index.js';
import '../../../feature/sliders/AuthSlider/index.js';
import '../../../feature/sliders/PromoSlider/index.js';
import '../../../feature/toast/ToastContent/index.js';
import '../../../feature/toast/ToastIcon/index.js';
import '../../../feature/toast/ToastPortal/index.js';
import 'react-toastify';
import '../../../feature/user/UserInfo/index.js';
import '../../../feature/user/AvatarName/index.js';
import '../../../feature/user/UserName/index.js';
import '../../../feature/user/UserCryptoLine/index.js';
import '../../../feature/user/UserRainLine/index.js';
import '../../../feature/user/UserInfoStat/index.js';
import '../../../feature/user/UserInfoWrapper/index.js';
import '../../../feature/wallet/CategoryList/index.js';
import '../../../feature/wallet/WalletTabs/index.js';
import '../../../feature/wallet/MainWrapper/index.js';
import '../../../feature/wallet/VerifyAccordion/index.js';
import '../../../feature/chat/wrappers/MainWrapper/index.js';
import '../../../feature/chat/wrappers/HeaderWrapper/index.js';
import '../../../feature/chat/wrappers/BodyWrapper/index.js';
import '../../../feature/chat/wrappers/FooterWrapper/index.js';
import '../../../feature/chat/components/MessagesInfo/index.js';
import '../../../feature/chat/components/Bet/index.js';
import '../../../feature/chat/components/Rain/index.js';
import '../../../feature/chat/components/Tip/index.js';
import '../../../feature/chat/components/UserName/index.js';
import '../../../feature/chat/components/UserTag/index.js';
import '../../../feature/chat/components/Comment/index.js';
import '../../../feature/chat/components/ActionList/index.js';
import '../../../feature/chat/components/ActionListPopper/index.js';
import '../../../feature/chat/components/Composer/index.js';
import '../../../feature/chat/components/ChatInput/index.js';
import '../../../feature/chat/components/PinnedСomment/index.js';
import '../../../feature/chat/components/ComposerState/index.js';
import '../../../feature/chat/components/ChatInfo/index.js';
import '../../../feature/preview/MaintainTimer/index.js';
import '../../../feature/tooltip/Tooltip/index.js';
import { EMBLA_NAVIGATION_DEFAULT_OPTIONS, EMBLA_DEFAULT_OPTIONS } from './types.js';
import styles from './index.module.scss.js';

const EmblaCarousel = ({
  slides = [],
  options = { ...EMBLA_DEFAULT_OPTIONS, ...EMBLA_NAVIGATION_DEFAULT_OPTIONS },
  title,
  additionalTitle,
  navigation,
  customControls = [],
  getActiveSlide = () => {
  },
  setEmblaApi = () => {
  },
  partialSlides,
  viewAll,
  withButtonSlider = false,
  shadow,
  text = {
    viewAll: "View All"
  },
  titleAnimation = {
    "data-aos": "fade-down-title",
    "data-aos-delay": "400",
    "data-aos-duration": "1000"
  },
  cardAnimation = {
    "data-aos": "fade-left",
    "data-aos-delay": 400,
    "data-aos-duration": "1000"
  },
  setSidesInView,
  ...props
}) => {
  const [emblaRef, emblaApi] = useEmblaCarousel(
    { ...options, dragFree: options.dragFree },
    [
      Fade({
        active: options.fade
      }),
      Autoplay({
        active: options.autoplay,
        playOnInit: options.playOnInit,
        delay: options.playDelay || 5e3,
        stopOnMouseEnter: true,
        stopOnInteraction: false
      }),
      WheelGesturesPlugin()
    ]
  );
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [, setScrollSnaps] = useState([]);
  const { isMobile } = useWindowSize();
  const slideSize = useMemo(() => {
    const desktopSlideSize = `calc((100% - ${options.slideSpacing || 0} * (${options?.slidesPerView || 1} - 1)) / ${options?.slidesPerView || 1})`;
    const mobileSlideSize = `calc((100% - ${options.mobileSpacing || 0} * (${+(options?.mobileSlidesPerView || 1)} - 1)) / ${+(options?.mobileSlidesPerView || 1)})`;
    const desktop = options.slidesPerView === "auto" ? "auto" : desktopSlideSize;
    return {
      desktop,
      mobile: !options.mobileSlidesPerView ? desktop : options.mobileSlidesPerView === "auto" ? "auto" : mobileSlideSize
    };
  }, [options]);
  const isPaddingTop = useMemo(
    () => !title && !navigation && !customControls.length,
    [title, navigation, customControls]
  );
  const onInit = useCallback((api) => {
    setScrollSnaps(api.scrollSnapList());
  }, []);
  const onSelect = useCallback((api) => {
    const index = api.selectedScrollSnap();
    setSelectedIndex(index);
    getActiveSlide(index);
    setSidesInView?.(api?.slidesInView());
  }, []);
  useEffect(() => {
    if (!emblaApi) return;
    onInit(emblaApi);
    onSelect(emblaApi);
    setEmblaApi(emblaApi);
    emblaApi.on("reInit", onInit);
    emblaApi.on("reInit", onSelect);
    emblaApi.on("select", onSelect);
  }, [emblaApi, onInit, onSelect]);
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      ...props,
      className: cx(styles.box, {
        [styles["padding-top"]]: isPaddingTop,
        [styles["partial-slides"]]: partialSlides,
        [styles["with-shadows"]]: withButtonSlider,
        [styles["right-disabled"]]: !emblaApi?.canScrollNext(),
        [styles["left-disabled"]]: !emblaApi?.canScrollPrev()
      }),
      style: {
        "--slide-size": slideSize.desktop,
        "--mobile-slide-size": slideSize.mobile,
        "--slide-spacing": options.slideSpacing,
        "--slide-spacing-m": options.mobileSpacing,
        "--viewport-offset": options.offset,
        "--viewport-offset-m": options.mobileOffset
      },
      "data-animation": "embla-box"
    },
    (title || navigation || !!customControls.length) && /* @__PURE__ */ React.createElement(
      SectionTitle,
      {
        className: styles["section-title"],
        title,
        additionalTitle,
        buttons: customControls,
        text,
        viewAll: !isMobile ? viewAll : "",
        animation: titleAnimation
      },
      !customControls.length && navigation && (emblaApi?.canScrollPrev() || emblaApi?.canScrollNext()) && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
        DirectionButton,
        {
          className: "hover-button",
          onClick: () => emblaApi?.scrollPrev(),
          disabled: !emblaApi?.canScrollPrev(),
          type: "button",
          "aria-label": "left-button",
          direction: "prev"
        }
      ), /* @__PURE__ */ React.createElement(
        DirectionButton,
        {
          className: "hover-button",
          onClick: () => emblaApi?.scrollNext(),
          disabled: !emblaApi?.canScrollNext(),
          type: "button",
          "aria-label": "right-button",
          direction: "next"
        }
      ))
    ),
    /* @__PURE__ */ React.createElement(
      "div",
      {
        className: cx(styles.viewport, {
          transitioned: shadow && emblaApi?.canScrollNext(),
          [styles.transitioned]: shadow && emblaApi?.canScrollNext(),
          [styles["no-shadow"]]: !shadow,
          [styles.shadow]: shadow && emblaApi?.canScrollNext()
        }),
        ref: emblaRef
      },
      /* @__PURE__ */ React.createElement("div", { className: styles.container }, slides.map((item, index) => /* @__PURE__ */ React.createElement(
        "div",
        {
          className: cx(styles.slide, "embla-slide", {
            "embla-active-slide": selectedIndex === index
          }),
          key: index,
          "data-animation": "embla-slide-wrapper",
          "data-slide-position": index
        },
        /* @__PURE__ */ React.createElement(
          "div",
          {
            className: styles["aos-wrapper"],
            "data-desktop-fixed-size": slideSize.desktop !== "auto",
            "data-mobile-fixed-size": slideSize.mobile !== "auto",
            ...cardAnimation,
            "data-aos-delay": Number(cardAnimation?.["data-aos-delay"] || 100) + index * Number(cardAnimation?.["data-aos-step"] || 50),
            "data-animation": "embla-slide-aos-wrapper"
          },
          item
        )
      ))),
      /* @__PURE__ */ React.createElement("div", null, withButtonSlider && (emblaApi?.canScrollPrev() || emblaApi?.canScrollNext()) ? /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
        DirectionButton,
        {
          className: styles["hover-button-carousel__prev"],
          onClick: () => emblaApi?.scrollPrev(),
          disabled: !emblaApi?.canScrollPrev(),
          type: "button",
          "aria-label": "left-button",
          direction: "prev"
        }
      ), /* @__PURE__ */ React.createElement(
        DirectionButton,
        {
          className: styles["hover-button-carousel__next"],
          onClick: () => emblaApi?.scrollNext(),
          disabled: !emblaApi?.canScrollNext(),
          type: "button",
          "aria-label": "right-button",
          direction: "next"
        }
      )) : null)
    )
  );
};
EmblaCarousel.displayName = "EmblaCarousel";

export { EmblaCarousel };
//# sourceMappingURL=index.js.map
